<template>
<div class="find-list">
  <newList v-if="userNewList && !hideList" @onToggleList="toggleListType" @showDemand="showDemand" ref="newList"></newList> 
  <oldList v-if="!userNewList && !hideList" @onToggleList="toggleListType" @showDemand="showDemand" ref="oldList"></oldList> 
  <!-- && !hideList
&& !hideList -->
  <!-- 需求表单 -->
  <DemandForm 
    v-if="hideList" 
    :show-cancel="false"
    @submit-success="onSubmitSuccess"
  />
</div>
</template>
<script>
import newList from "./newList.vue"
import oldList from "./oldList.vue"
import DemandForm from "@/components/DemandForm.vue"

export default {
    name:"findIndex",
    data(){
        return{
          userNewList:true,
          hideList:false
        }
    },
    methods:{
      // 切换列表类型的方法
      toggleListType(newType) {
        this.userNewList = newType === 'new';
        localStorage.setItem("find-list-type", newType);
      },
      showDemand(){
        console.log("hideList",this.hideList);
        // 隐藏列表，显示表单
        // if(this.$store.state.store_id!=1780){
        //   this.hideList = true;
        // }
      },
      // 表单提交成功回调
      onSubmitSuccess() {
        // 显示列表
        this.hideList = false;
        // 跳转到我的需求页
        
      }
    },
    created(){
      let type =  localStorage.getItem("find-list-type");
      this.userNewList = type=="new"
    },
    watch: {
      "$store.state.searchText": {
        deep: true,
        handler() {
          if(this.$store.state.store_id!=1780&&this.hideList){
            // 当搜索字段发生变化时，隐藏表单并重新显示列表
            this.hideList = false;
            // 重新执行搜索
            this.$nextTick(() => {
              if (this.userNewList && this.$refs.newList) {
                this.$refs.newList.query(1);
              } else if (!this.userNewList && this.$refs.oldList) {
                this.$refs.oldList.query();
              }
            });
          }
        }
      }
    },
    props:{
        
    },
    components:{
        newList,
        oldList,
        DemandForm
    },
}
</script>

<style lang="scss">
.find-list{
    // 切换按钮样式已移至子组件
}
</style>